// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2CWvU","error":"Textarea_error__3E9-k","readonly":"Textarea_readonly__2V_Pg","disabled":"Textarea_disabled__1Iv_G"};